import React from "react";
import "./AddAttendanceModal.css";

/**
 * Modal pour ajouter une nouvelle présence
 */
export function AddAttendanceModal({ isOpen, onClose, operators, onSubmit }) {
  const [formData, setFormData] = React.useState({
    date: new Date().toISOString().split('T')[0],
    operator_id: '',
    check_in: '',
    check_out: '',
    break_duration: '00:00'
  });
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.operator_id || !formData.check_in || !formData.check_out) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }
    
    setIsSubmitting(true);
    try {
      await onSubmit(formData);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Ajouter une présence</h3>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Date *</label>
            <input
              type="date"
              className="form-input"
              value={formData.date}
              onChange={(e) => handleChange('date', e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Opérateur *</label>
            <select
              className="form-select"
              value={formData.operator_id}
              onChange={(e) => handleChange('operator_id', e.target.value)}
              required
            >
              <option value="">Sélectionner un opérateur</option>
              {operators.map(op => (
                <option key={op.id} value={op.id}>{op.name}</option>
              ))}
            </select>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Heure d'arrivée *</label>
              <input
                type="time"
                className="form-input"
                value={formData.check_in}
                onChange={(e) => handleChange('check_in', e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Heure de départ *</label>
              <input
                type="time"
                className="form-input"
                value={formData.check_out}
                onChange={(e) => handleChange('check_out', e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Durée de la pause</label>
            <input
              type="time"
              className="form-input"
              value={formData.break_duration}
              onChange={(e) => handleChange('break_duration', e.target.value)}
            />
            <small className="form-hint">Format: HH:MM (ex: 01:00 pour 1h de pause)</small>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose} disabled={isSubmitting}>
              Annuler
            </button>
            <button type="submit" className="btn-submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <span className="spinner"></span>
                  Envoi...
                </>
              ) : (
                'Valider'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
